<mat-radio-group
  class="product-container"
  [formControl]="productControl"
  (change)="onProductChange()">

  @for (product of products; track product) {
    <div class="product-row"
      >
      <mat-radio-button
        class="product-radio-btn"
        color="primary"
        [value]="product.product_id"
        [attr.data-cy]="product.is_plan ? 'product-plan' : null"
        [attr.aria-labelledby]="'productLabel' + product.product_id">
        <p class="prod-label" [attr.id]="'productLabel' + product.product_id">
          {{ product.is_plan ? product.display_name : group.name }}
        </p>
      </mat-radio-button>
      <span class="prod-price">
        {{ product.price | currency: 'USD':'symbol':'1.2-2' }}
      </span>
    </div>
  }
</mat-radio-group>
